const getLineItemAttributes = ({ data, isLineItem, variant, gwpThreshold }) => {
  let lineAttributes = [];

  //   if (!data.horizontalImage?.value && !data.description) {
  //     lineAttributes = null;
  //     return lineAttributes;
  //   }

  if (data.apparelColorName) {
    lineAttributes = [
      ...lineAttributes,
      {
        key: '_apparel_color',
        value: data.apparelColorName?.value,
      },
      {
        key: '_apparel_size',
        value: variant.selectedOptions?.find((o) => o.name === 'Size').value,
      },
      {
        key: '_is_apparel',
        value: 'true',
      },
    ];
  }

  if (data.horizontalImage) {
    lineAttributes = [
      ...lineAttributes,
      {
        key: '_horizontal_image',
        value: data.horizontalImage?.value,
      },
    ];
  }
  if (data.description) {
    lineAttributes = [
      ...lineAttributes,
      {
        key: '_short_description',
        value: isLineItem ? data.description.value : data.description,
      },
    ];
  }

  if (data.tags?.indexOf('gwp' > -1)) {
    lineAttributes = [
      ...lineAttributes,
      {
        key: '_93067a65dac5',
        value: `${(gwpThreshold + 18417) * 5}`,
      },
    ];
  }

  return lineAttributes;
};

export default getLineItemAttributes;
